import { Component, type ReactNode } from 'react';
import { Link, useRouteError } from 'react-router';

export function NotFound() {
  return <div className="empty" style={{ height: '100%' }}><b>Page not found</b><span>That page doesn’t exist.</span><Link className="btn primary" to="/">Go to the dashboard</Link></div>;
}

export function RouteError() {
  const err = useRouteError();
  console.error(err);
  return (
    <div className="empty" style={{ height: '100vh' }}>
      <b>Something went wrong</b>
      <span>The page hit an unexpected problem. Your saved work is safe.</span>
      <button type="button" className="btn primary" onClick={() => location.reload()}>Reload</button>
    </div>
  );
}

/** Keeps one broken panel from taking down the whole dashboard. */
export class Boundary extends Component<{ children: ReactNode; label?: string }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  override componentDidCatch(error: Error) { console.error('[noorview]', this.props.label, error); }
  override render() {
    if (this.state.error) return (
      <div className="empty card glass"><b>{this.props.label ?? 'This panel'} couldn’t load</b>
        <button type="button" className="btn sm plain" onClick={() => this.setState({ error: null })}>Try again</button></div>
    );
    return this.props.children;
  }
}
